var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoiceChatIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1661 3.18838C12.7369 2.89554 11.2632 2.89554 9.8341 3.18838C9.39028 3.27932 9.04853 3.63458 8.97486 4.08159L8.92064 4.41058C8.47437 7.11843 8.47437 9.88108 8.92064 12.5889L8.97486 12.9179C9.04853 13.3649 9.39028 13.7202 9.8341 13.8111C11.2632 14.104 12.7369 14.104 14.1661 13.8111C14.6099 13.7202 14.9517 13.3649 15.0253 12.9179L15.0795 12.5889C15.5258 9.88108 15.5258 7.11843 15.0795 4.41058L15.0253 4.08159C14.9517 3.63458 14.6099 3.27932 14.1661 3.18838Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.89487 10.2572C5.30499 10.1991 5.68456 10.4844 5.74268 10.8945L6.19318 14.0738C6.3149 14.9328 6.99582 15.6045 7.8564 15.7144C10.6077 16.0658 13.3925 16.0658 16.1438 15.7144C17.0044 15.6045 17.6853 14.9328 17.807 14.0738L18.2575 10.8945C18.3156 10.4844 18.6952 10.1991 19.1053 10.2572C19.5154 10.3153 19.8008 10.6949 19.7427 11.105L19.2922 14.2843C19.0757 15.8122 17.8645 17.0068 16.3338 17.2023C15.1436 17.3543 13.9474 17.4435 12.7501 17.4697V21.4998C12.7501 21.914 12.4143 22.2498 12.0001 22.2498C11.5859 22.2498 11.2501 21.914 11.2501 21.4998V17.4697C10.0528 17.4435 8.8566 17.3543 7.66635 17.2023C6.13565 17.0068 4.92452 15.8122 4.70802 14.2843L4.25751 11.105C4.1994 10.6949 4.48475 10.3153 4.89487 10.2572Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceChatIcon);
export default __webpack_public_path__ + "static/media/voiceChatIcon.55ea91b4ceebaa850e5ce058a2b3a075.svg";
export { ForwardRef as ReactComponent };